import { FSharpRef, Record, Union } from "../fable_modules/fable-library.4.1.4/Types.js";
import { option_type, record_type, class_type, tuple_type, string_type, union_type, int32_type, obj_type } from "../fable_modules/fable-library.4.1.4/Reflection.js";
import { contains, ofList, FSharpSet_op_Addition, FSharpSet__Contains, FSharpSet__Add, FSharpSet__Remove, empty } from "../fable_modules/fable-library.4.1.4/Set.js";
import { Lazy, comparePrimitives, compareArrays } from "../fable_modules/fable-library.4.1.4/Util.js";
import { add, FSharpMap__Add, FSharpMap__TryFind, empty as empty_1 } from "../fable_modules/fable-library.4.1.4/Map.js";
import { singleton, empty as empty_2, collect, delay, toList } from "../fable_modules/fable-library.4.1.4/Seq.js";
import { toFail, join, compare, printf, toText, substring } from "../fable_modules/fable-library.4.1.4/String.js";
import { some, value as value_9 } from "../fable_modules/fable-library.4.1.4/Option.js";
import { rangeChar } from "../fable_modules/fable-library.4.1.4/Range.js";
import { ofArray, cons } from "../fable_modules/fable-library.4.1.4/List.js";
import { tryParse } from "../fable_modules/fable-library.4.1.4/Int32.js";
import { tryParse as tryParse_1 } from "../fable_modules/fable-library.4.1.4/Double.js";

export class ParseResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Success", "Fail"];
    }
}

export function ParseResult_$reflection() {
    return union_type("Packrat.ParseResult", [], ParseResult, () => [[["Item1", obj_type], ["Item2", int32_type]], []]);
}

export class ParseArgs extends Record {
    constructor(input, active, settled, externalContext) {
        super();
        this.input = input;
        this.active = active;
        this.settled = settled;
        this.externalContext = externalContext;
    }
}

export function ParseArgs_$reflection() {
    return record_type("Packrat.ParseArgs", [], ParseArgs, () => [["input", string_type], ["active", record_type("Microsoft.FSharp.Core.FSharpRef`1", [class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(int32_type, int32_type)])], FSharpRef, () => [["contents", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(int32_type, int32_type)])]])], ["settled", record_type("Microsoft.FSharp.Core.FSharpRef`1", [class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(int32_type, int32_type), ParseResult_$reflection()])], FSharpRef, () => [["contents", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [tuple_type(int32_type, int32_type), ParseResult_$reflection()])]])], ["externalContext", option_type(obj_type)]]);
}

export function ParseArgs_Init_E827B83(input, externalContext) {
    return [new ParseArgs(input, new FSharpRef(empty({
        Compare: compareArrays,
    })), new FSharpRef(empty_1({
        Compare: compareArrays,
    })), externalContext), 0];
}

export function ParseInputModule_analyze(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const input = _arg[0].input;
    const results = toList(delay(() => collect((matchValue) => {
        let arg_3, startPos, afterPos, input_1, before, after, mid;
        const activePatternResult = matchValue;
        const matchValue_1 = activePatternResult[1];
        if (matchValue_1.tag === 1) {
            return empty_2();
        }
        else {
            return singleton((arg_3 = ((startPos = (activePatternResult[0][0] | 0), (afterPos = (matchValue_1.fields[1] | 0), (input_1 = input, (before = substring(input_1, 0, startPos), (after = substring(input_1, afterPos), (mid = substring(input_1, startPos, afterPos - startPos), toText(printf("%s<<<%s>>>%s"))(before)(mid)(after)))))))), toText(printf("%s %A"))(arg_3)(matchValue_1.fields[0])));
        }
    }, _arg[0].settled.contents)));
    return ["..." + substring(input, _arg[1]), results];
}

export const ParseInputModule_$007CFailureAnalysis$007C = (tupledArg) => ParseInputModule_analyze(tupledArg[0], tupledArg[1]);

export function ExternalContextOf(_arg1_, _arg1__1) {
    const matchValue = _arg1_.externalContext;
    if (matchValue != null) {
        return some(value_9(matchValue));
    }
    else {
        return void 0;
    }
}

export const nextId = (() => {
    let i = 0;
    return () => {
        i = ((i + 1) | 0);
        return i | 0;
    };
})();

export function pack(rule) {
    const id = nextId() | 0;
    return (input) => {
        const pos = input[1] | 0;
        const ctx = input[0];
        const active$0027 = ctx.active.contents;
        const key = [pos, id];
        ctx.active.contents = FSharpSet__Remove(ctx.active.contents, key);
        const matchValue = FSharpMap__TryFind(ctx.settled.contents, key);
        if (matchValue == null) {
            const settled = ctx.settled.contents;
            const active = ctx.active.contents;
            ctx.active.contents = FSharpSet__Add(active, key);
            ctx.settled.contents = FSharpMap__Add(settled, key, new ParseResult(1, []));
            const evalResult = rule([ctx, pos]);
            const hadLeftRecursion = !FSharpSet__Contains(ctx.active.contents, key);
            ctx.active.contents = FSharpSet__Remove(ctx.active.contents, key);
            const grow_1 = (seed, settled_1) => {
                const grow = (seed_1_mut, settled_2_mut) => {
                    let v_1, rest;
                    grow:
                    while (true) {
                        const seed_1 = seed_1_mut, settled_2 = settled_2_mut;
                        ctx.settled.contents = settled_2;
                        const matchValue_1 = rule([ctx, pos]);
                        let matchResult, endpos_2, v_2, endpos_3, oldendpos_1, rest_1, v_3, endpos_4, v_4;
                        if (seed_1 != null) {
                            if (matchValue_1 != null) {
                                if ((v_1 = matchValue_1[0], (rest = matchValue_1, matchValue_1[1][1] > seed_1[1]))) {
                                    matchResult = 1;
                                    endpos_3 = matchValue_1[1][1];
                                    oldendpos_1 = seed_1[1];
                                    rest_1 = matchValue_1;
                                    v_3 = matchValue_1[0];
                                }
                                else {
                                    matchResult = 2;
                                    endpos_4 = seed_1[1];
                                    v_4 = seed_1[0];
                                }
                            }
                            else {
                                matchResult = 2;
                                endpos_4 = seed_1[1];
                                v_4 = seed_1[0];
                            }
                        }
                        else if (matchValue_1 == null) {
                            matchResult = 3;
                        }
                        else {
                            matchResult = 0;
                            endpos_2 = matchValue_1[1][1];
                            v_2 = matchValue_1[0];
                        }
                        switch (matchResult) {
                            case 0: {
                                seed_1_mut = [v_2, endpos_2];
                                settled_2_mut = add(key, new ParseResult(0, [v_2, endpos_2]), settled_2);
                                continue grow;
                            }
                            case 1: {
                                seed_1_mut = [v_3, endpos_3];
                                settled_2_mut = add(key, new ParseResult(0, [v_3, endpos_3]), settled_2);
                                continue grow;
                            }
                            case 2:
                                return [v_4, endpos_4];
                            default:
                                return void 0;
                        }
                        break;
                    }
                };
                const matchValue_3 = grow(seed, settled_1);
                if (matchValue_3 == null) {
                    ctx.settled.contents = add(key, new ParseResult(1, []), settled_1);
                    return void 0;
                }
                else {
                    const v_5 = matchValue_3[0];
                    const endpos_5 = matchValue_3[1] | 0;
                    ctx.settled.contents = add(key, new ParseResult(0, [v_5, endpos_5]), settled_1);
                    return [v_5, [ctx, endpos_5]];
                }
            };
            if (evalResult != null) {
                const v_6 = evalResult[0];
                const output = evalResult[1];
                const outpos = evalResult[1][1] | 0;
                const ctx_1 = evalResult[1][0];
                if (hadLeftRecursion) {
                    return grow_1([v_6, outpos], add(key, new ParseResult(0, [v_6, outpos]), settled));
                }
                else {
                    ctx_1.settled.contents = add(key, new ParseResult(0, [v_6, outpos]), ctx_1.settled.contents);
                    return [v_6, output];
                }
            }
            else if (hadLeftRecursion) {
                return grow_1(void 0, add(key, new ParseResult(1, []), settled));
            }
            else {
                ctx.settled.contents = add(key, new ParseResult(1, []), ctx.settled.contents);
                return void 0;
            }
        }
        else if (matchValue.tag === 1) {
            return void 0;
        }
        else {
            const endpos = matchValue.fields[1] | 0;
            const v = matchValue.fields[0];
            return [v, [ctx, endpos]];
        }
    };
}

export function $007CEnd$007C_$007C(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    if (_arg[1] === _arg[0].input.length) {
        return some(void 0);
    }
    else {
        return void 0;
    }
}

export function $007CStr$007C_$007C(str, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    if (((ix + str.length) <= ctx.input.length) && (compare(substring(ctx.input, ix, str.length), str, 3) === 0)) {
        return [ctx, ix + str.length];
    }
    else {
        return void 0;
    }
}

export function $007CPrecludeStr$007C_$007C(str, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    if (((ix + str.length) <= ctx.input.length) && (compare(substring(ctx.input, ix, str.length), str, 3) === 0)) {
        return void 0;
    }
    else {
        return [ctx, ix];
    }
}

export function $007CLookaheadStr$007C_$007C(str, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    if (((ix + str.length) <= ctx.input.length) && (compare(substring(ctx.input, ix, str.length), str, 3) === 0)) {
        return [ctx, ix];
    }
    else {
        return void 0;
    }
}

export function $007COptional$007C(str, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    if (((ix + str.length) <= ctx.input.length) && (compare(substring(ctx.input, ix, str.length), str, 3) === 0)) {
        return [ctx, ix + str.length];
    }
    else {
        return [ctx, ix];
    }
}

export const alpha = FSharpSet_op_Addition(ofList(toList(rangeChar("A", "Z")), {
    Compare: comparePrimitives,
}), ofList(toList(rangeChar("a", "z")), {
    Compare: comparePrimitives,
}));

export const numeric = ofList(toList(rangeChar("0", "9")), {
    Compare: comparePrimitives,
});

export const numericWithDecimal = ofList(cons(".", toList(rangeChar("0", "9"))), {
    Compare: comparePrimitives,
});

export const whitespace = ofList(ofArray([" ", "\t", "\n", "\r"]), {
    Compare: comparePrimitives,
});

export const alphanumeric = FSharpSet_op_Addition(alpha, numeric);

export const alphawhitespace = FSharpSet_op_Addition(alpha, whitespace);

export function $007CChar$007C_$007C(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    if (ix < ctx.input.length) {
        return [ctx.input[ix], [ctx, ix + 1]];
    }
    else {
        return void 0;
    }
}

export function $007CChars$007C_$007C(alphabet, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    const seek = (i_mut) => {
        seek:
        while (true) {
            const i = i_mut;
            if ((i < ctx.input.length) && contains(ctx.input[i], alphabet)) {
                i_mut = (i + 1);
                continue seek;
            }
            else {
                return i | 0;
            }
            break;
        }
    };
    const matchValue = seek(ix) | 0;
    if (matchValue > ix) {
        const endpos_1 = matchValue | 0;
        return [substring(ctx.input, ix, endpos_1 - ix), [ctx, endpos_1]];
    }
    else {
        return void 0;
    }
}

export function $007CCharsWhile$007C_$007C(predicate, alphabet, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    const seek = (biggestValid_mut, i_mut) => {
        seek:
        while (true) {
            const biggestValid = biggestValid_mut, i = i_mut;
            if (((i < ctx.input.length) && contains(ctx.input[i], alphabet)) && predicate(ctx.externalContext, substring(ctx.input, ix, i - ix))) {
                biggestValid_mut = i;
                i_mut = (i + 1);
                continue seek;
            }
            else {
                return biggestValid;
            }
            break;
        }
    };
    const matchValue = seek(void 0, ix);
    let matchResult, endpos_1;
    if (matchValue != null) {
        if (matchValue > ix) {
            matchResult = 0;
            endpos_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [substring(ctx.input, ix, endpos_1 - ix), [ctx, endpos_1]];
        default:
            return void 0;
    }
}

export function readBetween(start_, start__1, finish_, finish__1) {
    const start = [start_, start__1];
    const ix = start[1] | 0;
    return substring(start[0].input, ix, finish__1 - ix);
}

export function $007CCharsExcept$007C_$007C(exclusions, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    const seek = (i_mut) => {
        seek:
        while (true) {
            const i = i_mut;
            if ((i < ctx.input.length) && !contains(ctx.input[i], exclusions)) {
                i_mut = (i + 1);
                continue seek;
            }
            else {
                return i | 0;
            }
            break;
        }
    };
    const matchValue = seek(ix) | 0;
    if (matchValue > ix) {
        const endpos_1 = matchValue | 0;
        return [substring(ctx.input, ix, endpos_1 - ix), [ctx, endpos_1]];
    }
    else {
        return void 0;
    }
}

export function $007CLongestSubstringWhere$007C_$007C(pred, maxLength, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    const start = ix | 0;
    const seek = (i_mut, biggestMatch_mut) => {
        seek:
        while (true) {
            const i = i_mut, biggestMatch = biggestMatch_mut;
            if ((i <= ctx.input.length) && ((i - start) <= maxLength)) {
                if (pred(substring(ctx.input, start, i - start))) {
                    i_mut = (i + 1);
                    biggestMatch_mut = i;
                    continue seek;
                }
                else if (biggestMatch != null) {
                    return biggestMatch;
                }
                else {
                    i_mut = (i + 1);
                    biggestMatch_mut = biggestMatch;
                    continue seek;
                }
            }
            else {
                return biggestMatch;
            }
            break;
        }
    };
    const matchValue = seek(ix, void 0);
    if (matchValue != null) {
        const endpos = matchValue | 0;
        return [substring(ctx.input, ix, endpos - ix), [ctx, endpos]];
    }
    else {
        return void 0;
    }
}

export function $007CAnyCase$007C(input) {
    return input.toLowerCase();
}

export function $007CAny$007C(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ctx = _arg[0];
    return [substring(ctx.input, _arg[1]), [ctx, ctx.input.length]];
}

export function $007CAnyTrimmed$007C(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ctx = _arg[0];
    return [substring(ctx.input, _arg[1]).trim(), [ctx, ctx.input.length]];
}

export function $007COWS$007C(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ctx = _arg[0];
    const seek = (i_mut) => {
        seek:
        while (true) {
            const i = i_mut;
            if ((i < ctx.input.length) && contains(ctx.input[i], whitespace)) {
                i_mut = (i + 1);
                continue seek;
            }
            else {
                return i | 0;
            }
            break;
        }
    };
    return [ctx, seek(_arg[1])];
}

export function $007CWS$007C_$007C(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const ix = _arg[1] | 0;
    const ctx = _arg[0];
    const seek = (i_mut) => {
        seek:
        while (true) {
            const i = i_mut;
            if ((i < ctx.input.length) && contains(ctx.input[i], whitespace)) {
                i_mut = (i + 1);
                continue seek;
            }
            else {
                return i | 0;
            }
            break;
        }
    };
    const matchValue = seek(ix) | 0;
    if (matchValue > ix) {
        return [ctx, matchValue];
    }
    else {
        return void 0;
    }
}

export function $007COWSStr$007C_$007C(str, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const activePatternResult = $007COWS$007C(_arg[0], _arg[1]);
    const activePatternResult_1 = $007CStr$007C_$007C(str, activePatternResult[0], activePatternResult[1]);
    if (activePatternResult_1 != null) {
        const ctx = activePatternResult_1;
        return ctx;
    }
    else {
        return void 0;
    }
}

export const $007CIntNoWhitespace$007C_$007C = pack((_arg) => {
    const activePatternResult = $007CChars$007C_$007C(numeric, _arg[0], _arg[1]);
    if (activePatternResult != null) {
        const rest = activePatternResult[1];
        const v = activePatternResult[0];
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse(v, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
            outArg = (v_1 | 0);
        })), outArg];
        if (matchValue[0]) {
            return [matchValue[1], rest];
        }
        else {
            return void 0;
        }
    }
    else {
        return void 0;
    }
});

export const $007CInt$007C_$007C = pack((_arg) => {
    const activePatternResult = $007COWS$007C(_arg[0], _arg[1]);
    const activePatternResult_1 = $007CChars$007C_$007C(numeric, activePatternResult[0], activePatternResult[1]);
    if (activePatternResult_1 != null) {
        let activePatternResult_2;
        const tupledArg = activePatternResult_1[1];
        activePatternResult_2 = $007COWS$007C(tupledArg[0], tupledArg[1]);
        const v = activePatternResult_1[0];
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse(v, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
            outArg = (v_1 | 0);
        })), outArg];
        if (matchValue[0]) {
            return [matchValue[1], activePatternResult_2];
        }
        else {
            return void 0;
        }
    }
    else {
        return void 0;
    }
});

export const $007CDecimal$007C_$007C = pack((_arg) => {
    const activePatternResult = $007COWS$007C(_arg[0], _arg[1]);
    const activePatternResult_1 = $007CChars$007C_$007C(numericWithDecimal, activePatternResult[0], activePatternResult[1]);
    if (activePatternResult_1 != null) {
        let activePatternResult_2;
        const tupledArg = activePatternResult_1[1];
        activePatternResult_2 = $007COWS$007C(tupledArg[0], tupledArg[1]);
        const v = activePatternResult_1[0];
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse_1(v, new FSharpRef(() => outArg, (v_1) => {
            outArg = v_1;
        })), outArg];
        if (matchValue[0]) {
            return [matchValue[1], activePatternResult_2];
        }
        else {
            return void 0;
        }
    }
    else {
        return void 0;
    }
});

export const $007CWord$007C_$007C = pack((_arg) => {
    const activePatternResult = $007COWS$007C(_arg[0], _arg[1]);
    const activePatternResult_1 = $007CChars$007C_$007C(alphanumeric, activePatternResult[0], activePatternResult[1]);
    if (activePatternResult_1 != null) {
        let activePatternResult_2;
        const tupledArg = activePatternResult_1[1];
        activePatternResult_2 = $007COWS$007C(tupledArg[0], tupledArg[1]);
        const v = activePatternResult_1[0];
        return [v, activePatternResult_2];
    }
    else {
        return void 0;
    }
});

export function $007CKeyword$007C_$007C(keyword, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const activePatternResult = $007COWS$007C(_arg[0], _arg[1]);
    const activePatternResult_1 = $007CStr$007C_$007C(keyword, activePatternResult[0], activePatternResult[1]);
    if (activePatternResult_1 != null) {
        let activePatternResult_2;
        const tupledArg = activePatternResult_1;
        activePatternResult_2 = $007COWS$007C(tupledArg[0], tupledArg[1]);
        return activePatternResult_2;
    }
    else {
        return void 0;
    }
}

export function $007CWords$007C_$007C$0040254() {
    return pack((_arg) => {
        let matchResult, ctx, endix, ix, rest;
        const activePatternResult = $007CWords$007C_$007C$0040254$002D1.Value(_arg);
        if (activePatternResult != null) {
            const activePatternResult_1 = $007CWord$007C_$007C(activePatternResult[1]);
            if (activePatternResult_1 != null) {
                matchResult = 0;
                ctx = _arg[0];
                endix = activePatternResult_1[1][1];
                ix = _arg[1];
                rest = activePatternResult_1[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return [substring(ctx.input, ix, endix - ix).trim(), rest];
            default: {
                const activePatternResult_2 = $007CWord$007C_$007C(_arg);
                if (activePatternResult_2 != null) {
                    const rest_1 = activePatternResult_2[1];
                    const w = activePatternResult_2[0];
                    return [w, rest_1];
                }
                else {
                    return void 0;
                }
            }
        }
    });
}

export const $007CWords$007C_$007C$0040254$002D1 = new Lazy($007CWords$007C_$007C$0040254);

export const $007CWords$007C_$007C = $007CWords$007C_$007C$0040254$002D1.Value;

export function parser(recognizerRoot, txt) {
    let tupledArg;
    const matchValue = ParseArgs_Init_E827B83(txt);
    let matchResult, v;
    const activePatternResult = recognizerRoot(matchValue);
    if (activePatternResult != null) {
        if (((tupledArg = activePatternResult[1], $007CEnd$007C_$007C(tupledArg[0], tupledArg[1]))) != null) {
            matchResult = 0;
            v = activePatternResult[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return v;
        default: {
            const arg_1 = join("\n", ParseInputModule_$007CFailureAnalysis$007C(matchValue)[1]);
            return toFail(printf("Could not parse \'%s\'\nSuccessful matches: %s"))(txt)(arg_1);
        }
    }
}

export function parserWithExternalContext(recognizerRoot, ctx, txt) {
    let tupledArg;
    const matchValue = ParseArgs_Init_E827B83(txt, some(ctx));
    let matchResult, v;
    const activePatternResult = recognizerRoot(matchValue);
    if (activePatternResult != null) {
        if (((tupledArg = activePatternResult[1], $007CEnd$007C_$007C(tupledArg[0], tupledArg[1]))) != null) {
            matchResult = 0;
            v = activePatternResult[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return v;
        default: {
            const arg_1 = join("\n", ParseInputModule_$007CFailureAnalysis$007C(matchValue)[1]);
            return toFail(printf("Could not parse \'%s\'\nSuccessful matches: %s"))(txt)(arg_1);
        }
    }
}

//# sourceMappingURL=Packrat.fs.js.map
